import script from "./Structure.vue?vue&type=script&setup=true&lang=js"
export * from "./Structure.vue?vue&type=script&setup=true&lang=js"

import "./Structure.vue?vue&type=style&index=0&id=b4a3997c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4a3997c"]])

export default __exports__